import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Techs from "../Components/Tech";
import PageAboutMe from "../Pages/AboutMe";
import PageHome from "../Pages/Home";
import Home from "../Pages/Home";
import PageProjects from "../Pages/projects";
import PageTechs from "../Pages/Techs";

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/">
        <PageHome />
      </Route>
      <Route path="/techs">
        <PageTechs />
      </Route>
      <Route path="/aboutme">
        <PageAboutMe />
      </Route>
      <Route path="/projects">
        <PageProjects />
      </Route>
    </Switch>
  );
};
export default Routes;
